// extracted by mini-css-extract-plugin
module.exports = {"xs":"600"};